module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/PinusPumila/Kanagawa_PinusPumila_HadGEM2_RCP85_Now.png";